import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useGlobalContext } from '@/components/context'
import {
	selectFieldForAnswer,
	selectInvalidAnswers,
	selectMissingMandatoryFields,
} from '@/state/answer/selectors'
import { useFormContext } from '@/state/main-form/reducer'
import { useAppSelector } from '@/utils/hooks'
import { formUrl, publicFormUrl } from '@/utils/url'
import sideBarStyle from '../../common.module.sass'
import style from './index.module.sass'
import { InvalidAnswer } from './invalid-answer'
import { MissingAnswer } from './missing-answer'

export const AnswerErrorDisplay = () => {
	const globalContext = useGlobalContext()
	const formContext = useFormContext()
	const invalidAnswers = useAppSelector((s) =>
		selectInvalidAnswers(s).map((a) => ({ answer: a, field: selectFieldForAnswer(s, a) })),
	)
	const missingFields = useAppSelector((s) => selectMissingMandatoryFields(s))

	const [cachedMissingFields, _] = useState(missingFields)
	const [cachedInvalidAnswers, __] = useState(invalidAnswers)

	return (
		<div className={style.container}>
			<div className={sideBarStyle.sectionTitle}>Errors</div>
			{cachedMissingFields.length > 0 && (
				<div className={style.subtitle}>Fill out these fields to continue</div>
			)}
			{cachedMissingFields.map((el) => (
				<Link
					key={el.id}
					to={formContext.publicForm?.code ? publicFormUrl(formContext.publicForm.code, el.id) : formUrl({
						...globalContext,
						recordId: formContext.record.id,
						formId: formContext.form.id,
						highlightFieldId: el.id
					})}
				>
					<MissingAnswer field={el} />
				</Link>
			))}
			{cachedInvalidAnswers.length > 0 && (
				<div className={style.subtitle}>Fix these invalid fields to continue</div>
			)}
			{cachedInvalidAnswers.map((el) => (
				<Link
					key={el.field.id}
					to={formContext.publicForm?.code ? publicFormUrl(formContext.publicForm.code, el.field.id) : formUrl({
						...globalContext,
						recordId: formContext.record.id,
						formId: formContext.form.id,
						highlightFieldId: el.field.id
					})}
				>
					<InvalidAnswer answerId={el.answer.id} field={el.field} />
				</Link>
			))}
		</div>
	)
}
